import { createContext, useContext, useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import Swal from "sweetalert2";
import { UrlContext } from "./UrlContext";
import * as jose from "jose";
import io from "socket.io-client";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [userError, setUserError] = useState(false);
  const [adminUser, setAdminUser] = useState(false);
  const [accessUser, setAccessUser] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [msalAccount, setMsalAccount] = useState(null);
  const [checkToken, setCheckToken] = useState(false);
  const { instance } = useMsal();
  const [showSpan, setShowSpan] = useState(false);
  const { API_URL } = useContext(UrlContext);
  const [projNotifications, setProjNotifications] = useState([]);
  const [getToKnowNotifications, setGetToKnowNotifications] = useState([]);
  const [expertCallNotifications, setExpertCallNotifications] = useState([]);
  const [invitationsAccepted, setInvitationsAccepted] = useState([]);
  const [joinNotifications, setJoinNotifications] = useState([]);
  const [updateNotification, setUpdateNotification] = useState(false);
  const [clientNotifications, setClientNotifications] = useState([]);
  const [projectApplication, setProjectApplication] = useState(false);
  const [projectEndingNotifications, setProjectEndingNotifications] = useState(
    []
  );
  const [ratingNotifications, setRatingNotifications] = useState([]);
  const [clientFeedbackNotifications, setClientFeedbackNotifications] = useState([]);
  const [updateApplication, setUpdateApplication] = useState(true);
  const [scrappingProcess, setScrappingProcess] = useState(false);
  const ephToken = localStorage.getItem("eph-token");
  let token = "";
  if (ephToken) {
    token = JSON.parse(ephToken).value;
  }

  useEffect(() => {
    const account = instance.getAllAccounts();
    setMsalAccount(account);
    const getUserData = async () => {
      const url = `${API_URL}get-user-data`;
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.user.isActive == "no") {
            setUserError(true);
            localStorage.clear();
            window.location.href = "/";
          } else if (data.status === "success") {
            setUserData(data.user);
            if (setAccessUser) setAccessUser(data.user);
            if (data.user.roles && data.user.roles.includes("Admin")) {
              setAdminUser(true);
            }
          } else if (data.status === "error") {
            setUserError(true);

            setTimeout(() => {
              const logoutRequest = {
                account: msalAccount,
              };
              instance.logoutRedirect(logoutRequest);
              localStorage.removeItem("eph-token");
              localStorage.removeItem("accesstoken");
              window.location.href = "/";
            }, 2000);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    const getNotifications = async () => {
      await fetch(`${API_URL}notification-list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(),
      })
        .then((res) => res.json())
        .then((data) => {
          setNotifications(data.notifications);
          setProjNotifications(data.projectNotification);
          setGetToKnowNotifications(data.getToKnowCallNotifications);
          setExpertCallNotifications(data.expertCallNotifications);
          setInvitationsAccepted(data.invitationsAcceptedNotifications);
          setJoinNotifications(data.requestJoinNotifications);
          setClientNotifications(data.clientNotifications);
          setProjectEndingNotifications(data.projectEndingNotifications);
          setRatingNotifications(data.ratingNotifications);
          setClientFeedbackNotifications(data.clientFeedbackNotifications || []);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    getUserData();
    getNotifications();
  }, [updateNotification]);

  useEffect(() => {
    async function checkAccessToken() {
      if (!localStorage.getItem("accesstoken")) {
        let newToken = "";
        const request = {
          scopes: ["User.Read"],
          account: msalAccount[0],
        };
        await instance.initialize();
        await instance
          .acquireTokenSilent(request)
          .then((response) => {
            console.log("creating new token");
            newToken = response.accessToken;
            localStorage.setItem("accesstoken", newToken);
          })
          .catch((err) =>
            Swal.fire({
              text: `${err.message}`,
              icon: "error",
              confirmButtonText: "Ok",
            })
          );
      } else {
        const exp = jose.decodeJwt(localStorage.getItem("accesstoken")).exp;
        if (Math.trunc(Date.now() / 1000 + 1200) >= exp) {
          let newToken = "";
          const request = {
            scopes: ["User.Read"],
            account: msalAccount[0],
          };
          await instance.initialize();
          await instance
            .acquireTokenSilent(request)
            .then((response) => {
              console.log("changing expired token");
              newToken = response.accessToken;
              localStorage.setItem("accesstoken", newToken);
            })
            .catch((err) =>
              Swal.fire({
                text: `${err.message}`,
                icon: "error",
                confirmButtonText: "Ok",
              })
            );
        }
      }
    }
    if (msalAccount?.length) {
      checkAccessToken();
    }
  }, [msalAccount, userData, checkToken]);

  setTimeout(() => {
    setCheckToken(!checkToken);
  }, 300000);

  useEffect(() => {
    const socketURL = API_URL.replace(/\/api\/$/, "");

    const socket = io(socketURL, {
      path: "/socket.io/",
      transports: ["websocket"],
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      auth: { token },
    });

    socket.on("new-notification", () => {
      setUpdateNotification(!updateNotification);
    });

    socket.on("new-project-application", () => {
      setProjectApplication(Date.now());
    });

    socket.on("update_available", () => {
      setShowSpan(true);
    });
    socket.on("new-application", () => {
      setUpdateApplication(!updateApplication);
    });
    socket.on("scrape-start", () => {
      console.log("scrape-star");
      setScrappingProcess(true);
    });
    socket.on("scrape-finish", () => {
      console.log("scrape-finish");
      setScrappingProcess(false);
    });
    socket.on("connect", () => {
      console.log("Connected to socket at", socketURL);
    });

    socket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
    });

    socket.on("disconnect", () => {
      console.log("Disconnected from socket");
    });

    return () => {
      socket.off("update_available");
      socket.off("connect");
      socket.off("disconnect");
      socket.disconnect();
    };
  }, []);
  return (
    <UserContext.Provider
      value={{
        userData,
        userError,
        adminUser,
        accessUser,
        notifications,
        setNotifications,
        projNotifications,
        setProjNotifications,
        msalAccount,
        getToKnowNotifications,
        setGetToKnowNotifications,
        expertCallNotifications,
        setExpertCallNotifications,
        invitationsAccepted,
        setInvitationsAccepted,
        joinNotifications,
        setJoinNotifications,
        clientNotifications,
        setClientNotifications,
        projectEndingNotifications,
        setProjectEndingNotifications,
        ratingNotifications,
        setRatingNotifications,
        clientFeedbackNotifications,
        setClientFeedbackNotifications,
        projectApplication,
        showSpan,
        updateApplication,
        scrappingProcess,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
